/**
 * Lingua: Italiano.
 */
export default {
    time: {
        openingHoursTitle: "Orari di apertura",
        at: "alle",
	to: "alle",
        opensToday: "Aperto oggi",
        opens: "Aperto",
        open24_7: "Aperto 24/7",
        closed: "Chiuso",
        openUntil: "Aperto oggi fino a",
        daily: "Aperto tutti i giorni dalle",
        month: [
            'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
            'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
        ],
        monthAbbr: [
            'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu',
            'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'
        ],
        dayOfWeek: [
            'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato','Domenica', 
        ],
        dayOfWeekAbbr: [
            'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom',
        ],
        temporarilyClosed: "Chiuso temporaneamente",
        opened: "",
        today: ""
    },
    search: {
        placeholder: "Via, città o codice postale",
        submitLabel: "Cerca",
        clearLabel: "Cancella ricerca",
        yourLocation: "La tua posizione",
    },
    filtering: {
        servicesTitle: "Servizi",
        services: {
            WF: 'Punto di accesso Wireless',
            CD: 'Pagamento Mobile',
            DT: 'Drive-Thru',
            DR: 'Premi Digitali',
            hrs24: 'Aperto 24 ore al giorno',
            WA: 'Cibo riscaldato in forno',
            LB: 'LaBoulange',
            XO: 'Ordina e Paga con il Cellulare',
            VS: 'Verismo',
            NB: 'Nitro Cold Brew',
            CL: 'Starbucks Reserve-Clover Brewed',
        }
    },
    stores: {
        cta: {
            call: "Chiama",
            directions: "Indicazioni",
            website: "Sito web",
            'club details': 'Dettagli',
            'view tariffs': 'Iscriviti',
            'View Map': "Visualizza mappa",
            'View List': "Visualizza lista"
        },
        messages: {
            initialHeader: "Inizia cercando una località per visualizzare le palestre nelle vicinanze",
            emptyHeader: "Nessuna palestra trovata",
            initialBody: "oppure clicca sulla mappa per selezionare una palestra",
            emptyBody: "Effettua una ricerca in un'altra località o deseleziona i filtri"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Autostrade',
            tolls: 'Pedaggi',
            ferries: 'Traghetti'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'miglia'
        },
        options: "Opzioni percorso",
        avoid: "Evita",
        units: "Unità di distanza",
        messages: {
            initialBody: "Cerca un punto di partenza e una destinazione per vedere i percorsi disponibili e il tempo di percorrenza.",
            error: "Spiacenti, impossibile calcolare le indicazioni stradali",
            from: "da",
            to: "a",
            forTravelMode: "per la modalità di viaggio",
            via: "tramite",
            details: "Dettagli",
            withoutTraffic: "senza traffico",
            openGoogleMaps: "apri in Google Maps"
        }
    },
    errors: {
        loadingLibrary: "impossibile caricare lo script {library}",
        geolocationFailed: "Geolocalizzazione utente non riuscita",
        apiErrors:{
            "401": "Non autorizzato",
            "403": "Vietato",
            "429": "Troppe richieste",
            "500": "Errore del server interno",
            other: "Si è verificato un errore imprevisto del server"
        }
    },
};